<template>
    <div
        :class="'triangle-defaults triangle-' + corner"
        :style="
            'border-bottom: ' + borderBottom + 
            ';  border-left: ' + borderLeft + 
            '; border-right: ' + borderRight + 
            '; width: ' + width + ';'"
    ></div>
</template>

<script>
export default {
    name: 'TriangleDiv',
    props: {
        /**
         * The corner of the parent container the traingle
         * should reside in.
         * @values top-left, top-right, bottom-left, bottom-right
         */
        corner: {
            type: String,
            default: 'bottom-right'
        },
        /**
         * The border that should be applied to the
         * bottom of the triangle (include color.)
         */
        borderBottom: {
            type: String,
            default: '100px solid #00B1C3'
        },
        /**
         * The border that should be applied to the
         * left of the triangle (include color.)
         */
        borderLeft: {
            type: String,
            default: '180px solid transparent'
        },
        /**
         * The border that should be applied to the
         * right of the triangle (include color.)
         */
        borderRight: {
            type: String,
            default: '0px solid transparent'
        },
        /**
         * The width that should be applied to the
         * triangle.
         */
        width: {
            type: String,
            default: '100px'
        }
    }
}
</script>

<style scoped>

.triangle-defaults {
    height: 0;
    position: absolute;
    z-index: 2;
}

.triangle-top-right {
    top: 0;
    right: 0;
}

.triangle-top-left {
    top: 0;
    left: 0;
}

.triangle-bottom-right {
    bottom: 0;
    right: 0;
}

.triangle-bottom-left {
    bottom: 0;
    left: 0;
}
</style>
